import _ from 'lodash';
import React from 'react';
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../../common/components/form/form.module';

export const GlobalConfiguartionBasicInfoComponent = ({ chosenGlobalConfigurations, handleInnerFormChange}: any) => {

    return (
        <>
  <AccordionContainer
                  child={
                    <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
                        <InputContainer
                          label="Domain Name"
                          labelField="Domain Name"
                          onValueChange={(event: any, newValue: any) => {
                            handleInnerFormChange(
                              event.target.value,
                              'DomainConfigurations.DomainName',
                              chosenGlobalConfigurations?.DomainConfigurations,
                            );
                          }}
                          type="text"
                          value={chosenGlobalConfigurations?.DomainConfigurations?.DomainName}
                        />
                      </div>
                  }
                  expandedPanel="BasicInfo"
                  headerTitle="BasicInfo"
                />
    </>
  )
}
export default GlobalConfiguartionBasicInfoComponent;
